import React, { useState, useEffect } from 'react';
import { XCircle, RotateCcw } from 'lucide-react';

const PaymentError = () => {
    const [countdown, setCountdown] = useState(8);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    window.close();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-950 px-6" data-testid="payment-error">
            <div className="text-center max-w-sm">
                <div className="relative mx-auto w-24 h-24 mb-8">
                    <div className="absolute inset-0 rounded-full bg-red-500/20 animate-pulse" style={{ animationDuration: '2s' }} />
                    <div className="relative flex items-center justify-center w-24 h-24 rounded-full bg-red-500/10 border-2 border-red-500/40">
                        <XCircle size={48} className="text-red-400" strokeWidth={1.5} />
                    </div>
                </div>

                <h1 className="text-3xl font-bold text-white mb-3">Paiement &eacute;chou&eacute;</h1>
                <p className="text-slate-400 mb-2">Le paiement n'a pas pu &ecirc;tre finalis&eacute;.</p>
                <p className="text-slate-400 text-sm mb-8">Veuillez r&eacute;essayer ou contacter le support.</p>

                <div className="flex flex-col gap-3 items-center">
                    <button
                        onClick={() => window.history.back()}
                        className="flex items-center gap-2 px-6 py-3 rounded-full bg-blue-600 hover:bg-blue-500 text-white font-medium transition-colors"
                    >
                        <RotateCcw size={16} /> R&eacute;essayer
                    </button>

                    <div className="glass-card p-4 inline-block mt-4">
                        <p className="text-slate-500 text-xs">
                            Fermeture automatique dans <span className="text-white font-bold">{countdown}s</span>
                        </p>
                    </div>

                    <button
                        onClick={() => window.close()}
                        className="text-sm text-slate-500 hover:text-white transition-colors underline underline-offset-4"
                    >
                        Fermer maintenant
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentError;
